export default __webpack_public_path__ + "static/media/welcome-cafgu.5573c4b6.svg";